export const getMaxLength = (type) => {
    if (type === 'description') return 45;
    if (type === 'brand') return 25;
    return 0;
};


export const getProductsListAfterValidation = (
    details,
    validatedProducts,
    isSetDetail,
    selectedSegment,
) => {
    const itemType = isSetDetail ? details?.billOfMaterials : details?.foundInSets;
    let products =
        selectedSegment === '0'
            ? itemType
            : details.relatedProducts;
    if (validatedProducts?.length > 0) {
        products =
            (isSetDetail
                ? (details.cfn || details.bom)
                : details.cfn) === validatedProducts[0].productCFN
                ? [details]
                : products;
        for (let i in products) {
            const productCfn= isSetDetail?(products[i].cfn || products[i].bom):products[i].cfn;
            if (productCfn === validatedProducts[0]?.productCFN) {
                products[i].productAdded = validatedProducts[0].productAdded;
                break;
            }
        }
    }
    if (
        validatedProducts?.length > 0 &&
        details.cfn === validatedProducts[0]?.productCFN
    ) {
        return {
            ...products[0],
        };
    } else if (selectedSegment === '0') {
        return {
            ...details,
            foundInSets: products,
        };
    } else {
        return {
            ...details,
            relatedProducts: products,
        };
    }
};

// You can pass dispatch and all needed params from your component
export const getInitialList = ({
    item,
    dispatch,
    isEquity,
    isConsignmentAdd,
    getEquityProductDetails,
    getConsignmentAddProductDetails,
    getProductDetails,
    EQUITYORDERTYPE,
    isSetDetail,
}) => {
    const { cfn, salesOrg, bom, orderType } = item;
    const resourceType = isSetDetail
        ? 'BILL_OF_MATERIALS,RELATED_PRODUCTS'
        : 'FOUND_IN_SETS,RELATED_PRODUCTS';
    dispatch(
        isEquity
            ? getEquityProductDetails({
                  productCFN: bom || cfn,
                  salesOrg: salesOrg,
                  orderType: orderType ? orderType : isSetDetail ? EQUITYORDERTYPE : 'ZOR',
                  resourceType: resourceType,
              })
            : isConsignmentAdd
            ? getConsignmentAddProductDetails({
                  productCFN: bom || cfn,
                  salesOrg: salesOrg,
                  orderType: orderType ? orderType : 'KB',
                  resourceType: resourceType,
              })
            : getProductDetails({
                  productCFN: bom || cfn,
                  salesOrg: salesOrg,
                  orderType: orderType ? orderType : 'ZLC',
                  resourceType: resourceType,
              })
    );
};
